import { createSelector } from "reselect";

import {
  selectVendorCommissionBandIdsByBusinessIdLookup,
  selectVendorCommissionBandIdsByDeploymentIdLookup,
} from "./indexes";
import {
  getEntryKeyIsUUID,
  objectMapper,
  createLookupCombiner,
  createLookupSelectors,
} from "./lib";
import { bestFitForSale } from "lib/sale";
import { getSales, getVendorCommissionBands } from "./root";

export const vendorCommissionBandDeploymentMapper = (
  vendorCommissionBandIds: string[],
  vendorCommissionBands: Record<string, VendorCommissionBand>,
) =>
  vendorCommissionBandIds
    .filter(cbId => !vendorCommissionBands[cbId].businessId)
    .map(cbId => vendorCommissionBands[cbId]);

export const [
  selectVendorCommissionBandsByDeploymentIdLookup,
  getVendorCommissionBandsByDeploymentId,
] = createLookupSelectors(
  [selectVendorCommissionBandIdsByDeploymentIdLookup, getVendorCommissionBands],
  createLookupCombiner(vendorCommissionBandDeploymentMapper),
);

export const [
  selectVendorCommissionBandsByBusinessIdLookup,
  getVendorCommissionBandsByBusinessId,
] = createLookupSelectors(
  [selectVendorCommissionBandIdsByBusinessIdLookup, getVendorCommissionBands],
  createLookupCombiner(objectMapper, getEntryKeyIsUUID),
);

export const selectDefaultVendorCommissionBandByDeploymentSaleId =
  createSelector(
    [selectVendorCommissionBandsByDeploymentIdLookup, getSales],
    (
      vendorCommissionBandsByDeploymentIdLookup: Record<
        number,
        VendorCommissionBand[]
      >,
      saleLookup: StateModelById<Sale>,
    ) => {
      // Find the most specific vendor commission defaults for a deploymentSale.
      return Object.values(saleLookup).reduce(
        (
          acc: Record<number, VendorCommissionBand | null>,
          livestockSale: Sale,
        ) => {
          livestockSale.deployment_sales.forEach(deploymentSale => {
            acc[deploymentSale.deployment_sale_id] =
              bestFitForSale(
                livestockSale,
                vendorCommissionBandsByDeploymentIdLookup[
                  deploymentSale.deployment_id
                ] || [],
              ) || null;
          });
          return acc;
        },
        {},
      );
    },
  );
